import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer-legal-notice',
  template: `
    <div class="mt-8">
      <span class="footer">{{ 'footer.legal_notice' | translate }}</span>
    </div>
  `,
  imports: [TranslateModule],
})
export class FooterLegalNoticeComponent {}
